import SimpleLayout from '../../../layouts/SimpleLayout';
import logo from '../../../assets/img/logo.png';
import illustration from '../../../assets/img/svg/unsupported-browser.svg';
import { Helmet } from 'react-helmet-async';

const UnsupportedBrowserPage = () => {
    return (
        <>
            <Helmet>
                <title>Navigateur non pris en charge :: Portail PETROSIL</title>
            </Helmet>

            <div className="page page-center">
                <div className="container-tight py-4">
                    <div className="text-center">
                        <a href="/" className="navbar-brand navbar-brand-autodark">
                            <img src={logo} alt="Logo" width="150" height="auto" />
                        </a>
                    </div>
                    <div className="empty">
                        <p className="empty-title">Navigateur non pris en charge</p>

                        <p className="empty-subtitle text-secondary">Votre navigateur est trop ancien pour afficher ce site. Merci de mettre à jour votre navigateur.</p>

                        <p>
                            <a href="https://www.google.com/chrome/" target="_blank" rel="noopener noreferrer">
                                Télécharger Google Chrome
                            </a>
                        </p>

                        <div className="mt-2 mb-2">
                            <img src={illustration} alt="Navigateur non pris en charge" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

UnsupportedBrowserPage.Layout = SimpleLayout;

export default UnsupportedBrowserPage;
